var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCix(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_722_32903)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9 18C13.9706 18 18 13.9706 18 9C18 4.02944 13.9706 0 9 0C4.02944 0 0 4.02944 0 9C0 13.9706 4.02944 18 9 18Z",
    fill: "#0576B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.8757 10.6105L13.28 10.2376L14.5794 10.2224L14.6064 10.2077V10.2218L15.143 10.2162L14.2324 11.6978L14.1508 10.9834L10.0085 13.2689L8.43749 11.1713L4.03311 13.4922V12.9634L8.57417 10.5711L10.1447 12.6687L13.8763 10.6105H13.8757ZM8.18774 10.1014L6.46649 11.0076V4.8623H8.18774V10.1014ZM13.055 10.372L11.3338 11.3282V4.8623H13.055V10.372Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M10.6217 11.7242L10.2521 11.929L8.89987 10.1234V5.56543H10.6211L10.6217 11.7242ZM5.75381 11.3828L4.03256 12.2896V6.36305H5.75381V11.3828Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_722_32903"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCix);
export default __webpack_public_path__ + "static/media/cix.ec5844eb4b53775674d9debe8223bafc.svg";
export { ForwardRef as ReactComponent };